<template>

<!-- Custom Alert/Modal Component -->
    <div v-if="modal.isVisible" class="modal-overlay">
      <div 
        class="modal-content"
        :style="{
          // Dynamic border color based on type
          'border-top': '4px solid ' + (
            modal.type === 'success' ? '#10b981' :         // green-500
            (modal.type === 'error' || modal.type === 'failure' ? '#ef4444' : '#3b82f6') // red-500 or blue-500
          )
        }"
      >
        <h3 class="modal-title" 
            :style="{
              'color': (modal.type === 'success' ? '#059669' : (modal.type === 'error' || modal.type === 'failure' ? '#dc2626' : '#1d4ed8')) 
            }">
          {{ modal.title }}
        </h3>
        <p class="modal-message">{{ modal.message }}</p>
        <div class="modal-actions">
          <button @click="hideModal" class="modal-button">
            Close
          </button>
        </div>
      </div>
    </div>
    


  <div>
    <NavigationBarTop />
    
    <div class="main-service-view">
        
        <AllServiceComponent 
            v-if="!selectedService"
            @select-service="handleServiceSelection"
        />

        <SelectDnTService 
            v-else-if="!bookingDetails"
            :service-data="selectedService"
            :comp="componentIs"
            @select-another-service="handleGoBack"
            @continue-to-form="handleContinueToForm"
        />

        <ServiceForm 
            v-else-if="!stripeClientSecret"
            :final-booking="bookingDetails"
            @go-back-to-dt="handleGoBackToDnT"
            @complete-booking="handleFinalBooking"
        />

        <StripePaymentForm
        v-else
        :client-secret="stripeClientSecret"
        :booking-id="bookingDetails.slot_id" 
        @payment-success="handlePaymentSuccess"
    />

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NavigationBarTop from '@/components/NavigationBarTop.vue'
import AllServiceComponent from '@/components/AllServiceComponent.vue'
import SelectDnTService from '@/components/SelectDnTService.vue' 
import ServiceForm from '@/components/ServiceForm.vue'
import SelectedServiceData from '../assets/services/selectedService.json'
import StripePaymentForm from '@/components/StripePaymentForm.vue'

import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

const MOCK_API = `${process.env.VUE_APP_API_URL}/payment/create-payment`
export default {
    name: 'ServiceManager',
    components : {
        NavigationBarTop,
        AllServiceComponent,
        SelectDnTService,
        ServiceForm,
        StripePaymentForm
    },
    async mounted() {
        // this.stripe = await stripePromise
        this.handleStripeRedirectResult()
    },
    data() {
        return {
            // This state variable determines which component is shown
            selectedService: null, 
            bookingDetails: null,
            allBookings: SelectedServiceData,

            stripeClientSecret: null,
            details : null,
            stripe: null,
            componentIs: "services",

            // Custom Modal State
            modal: {
                isVisible: false,
                title: '',
                message: '',
                type: 'info' // success, error, info, failure
            },
        }
    },
    methods: {
        // Modal Handlers
        showModal(title, message, type = 'info') {
            this.modal = { isVisible: true, title, message, type };
        },
        hideModal() {
            this.modal.isVisible = false;

            this.modal.title = '';
            this.modal.message = '';
        },
        handleServiceSelection(service) {
            this.selectedService = service;
            console.log(this.bookingDetails)
            window.scrollTo(0, 0); 
        },

        //Transition from Date/Time to Form
        handleContinueToForm(details) {
            this.details = details
            this.bookingDetails = details;
            window.scrollTo(0, 0); 
        },

        //Go back from Form to Date/Time
        handleGoBackToDnT() {
            this.bookingDetails = null;
            window.scrollTo(0, 0); 
        },
        async handleFinalBooking(finalData) {

            this.bookingDetails = finalData;

            // Needs to match this "2025-11-10 18:00:00+00:00"
            /** We are depracating this section because the frontend time doesn't 
             * match the backend time
             
            const fullStartTime = `${finalData.date}T${finalData.startTime}:00`;
            const amountInCents = finalData.servicePrice;
            //const amountInCents = Math.round(parseFloat(finalData.servicePrice));
                try {
                    const response = await axios.post(`${MOCK_API}`, {
                        amount: amountInCents,
                        currency: 'usd',
                        client_email: finalData.user.email,
                        full_name: finalData.user.name,
                        phone_number: finalData.user.phone,
                        start_time: fullStartTime, // Now "2026-01-30 09:00:00"
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        service_id: finalData.serviceId,
                        slot_id: finalData.slot_id,
                        recaptcha_token: finalData.recaptcha_token
        });*/
            // 1. Ensure date is YYYY-MM-DD and time is HH:MM
        // This prevents "8/4/2026" or other locale-specific formats from breaking the string
        const formattedDate = new Date(finalData.date).toISOString().split('T')[0];
        
        // 2. Construct the strict ISO string
        const fullStartTime = `${formattedDate}T${finalData.startTime}:00`;

        console.log("PAYLOAD BEING SENT:", {
    amount: finalData.servicePrice,
    email: finalData.user.email,
    name: finalData.user.name,
    slot: finalData.slot_id,
    start: fullStartTime
});

        try {
            const response = await axios.post(`${MOCK_API}`, {
                amount: finalData.servicePrice,
                currency: 'usd',
                client_email: finalData.user.email,
                full_name: finalData.user.name,
                phone_number: finalData.user.phone,
                start_time: fullStartTime, // "2026-04-08T14:30:00"
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                service_id: finalData.serviceId,
                slot_id: finalData.slot_id,
                recaptcha_token: finalData.recaptcha_token
            });

                // On successful registration
                const clientSecret = response.data.client_secret;

                if (clientSecret) {
                    this.stripeClientSecret = clientSecret
                } else {
                    console.error("Payment intent creation failed: ", response.data)
                    this.showModal('Payment Error',"Could not start payment process, please try again. ", 'error')
                }
            } catch(error) {
    // 1. Log the specific server response data
    if (error.response && error.response.data) {
        console.error("SERVER REJECTION DETAILS:", error.response.data);
        
        // This usually contains the 'message' or 'error' key from your Flask JSON response
        const backendMessage = error.response.data.message || error.response.data.error || "Validation failed";
        this.showModal('Booking Error', `Server rejected: ${backendMessage}`, 'error');
    } else {
        // 2. Log generic connection issues
        console.error("FULL ERROR OBJECT:", error);
        this.showModal('Connection Error', "Could not connect to the payment server.", 'error');
    }}
        },

        handlePaymentSuccess() {

            const userName = this.bookingDetails?.user?.name || 'Valued Customer';

            this.showModal('Payment Successful!',`Payment Successful! Booking Confirmed! Thank you, ${userName}`, 'success')
            /*this.$router.push({ 
                name: 'services', 
                //query: { payment_status: 'success' } 
            });
            // Reset state to initial view*/
            this.resetBookingState()
            window.location.href = '/services'
        },

        resetBookingState(){
            this.selectedService = null;
            this.bookingDetails = null;
            this.stripeClientSecret = null;
            window.scrollTo(0, 0);
            console.log("Resetted")
        },

        async handleStripeRedirectResult() {
            // Check if Stripe has added its query parameters after a redirect
            const urlParams = new URLSearchParams(window.location.search);
            const paymentIntentClientSecret = urlParams.get('payment_intent_client_secret');
            const resultFlag = urlParams.get('payment_intent_result');

            // Only run if we detect the custom flag and the client secret from Stripe
            if (resultFlag && paymentIntentClientSecret && this.stripe) {
                
                // Retrieve the payment intent using the client secret
                const { paymentIntent, error } = await this.stripe.retrievePaymentIntent(
                    paymentIntentClientSecret
                );

                if (error) {
                    this.showModal('Payment Error','Payment processing failed. Please try again.', 'error');
                    console.error("Retrieve Payment Intent Error:", error);
                } else if (paymentIntent) {
                    // Handle the payment status
                    switch (paymentIntent.status) {
                        case 'succeeded':
                            this.showModal('Payment Successful','Payment Succeeded! Your booking is confirmed.', 'success');
                            
                            this.$router.replace({ query: {} }); // Clear query params
                            this.resetBookingState();
                            break;
                        case 'processing':
                            this.showModal('Payment Processing',"Payment is processing. We'll notify you once it's complete.", 'info');
                            this.$router.replace({ query: {} });
                            this.resetBookingState();
                            break;
                        case 'requires_payment_method':
                        case 'requires_action':
                            // The user canceled the 3D Secure step, or card declined
                            this.showModal('Payment Failed','Payment failed or was canceled. Please try again.', 'failure');
                            this.$router.replace({ query: {} });
                            // Option: Redirect the user back to the payment form to retry
                            this.stripeClientSecret = paymentIntentClientSecret; // Keep the existing secret to try again
                            break;
                        default:
                            this.showModal('Payment Status Unknown','An unexpected payment status was received. Please check your email for confirmation.', 'info');
                            this.$router.replace({ query: {} });
                            this.resetBookingState();
                            break;
                    }
                }
            }

            // Also handle the internal success message from local redirect
             if (this.$route.query.payment_status === 'success') {
                this.$router.replace({ query: {} });
            }
        },

        handleGoBack() {
            this.selectedService = null;
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
 .modal-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(31, 41, 55, 0.75); /* bg-gray-800 bg-opacity-75 */
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 50; /* z-50 */
        padding: 1rem; /* p-4 */
    }

    .modal-content {
        background-color: #fff; /* bg-white */
        border-radius: 0.75rem; /* rounded-xl */
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */
        padding: 1.5rem; /* p-6 */
        width: 100%; /* w-full */
        max-width: 28rem; /* max-w-md */
        transition: transform 0.3s ease-in-out; /* transition-all duration-300 transform */
    }

    .modal-title {
        font-size: 1.25rem; /* text-xl */
        font-weight: 700; /* font-bold */
        margin-bottom: 0.75rem; /* mb-3 */
    }

    .modal-message {
        color: #4b5563; /* text-gray-700 */
        margin-bottom: 1.5rem; /* mb-6 */
        white-space: pre-line; /* whitespace-pre-line */
    }

    .modal-actions {
        display: flex; /* flex */
        justify-content: flex-end; /* justify-end */
    }

    .modal-button {
        padding: 0.5rem 1rem; /* px-4 py-2 */
        background-color: #2563eb; /* bg-blue-600 */
        color: #fff; /* text-white */
        font-weight: 500; /* font-medium */
        border-radius: 0.5rem; /* rounded-lg */
        transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; /* transition duration-150 */
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1); /* shadow-md */
        border: none;
        cursor: pointer;
    }

    .modal-button:hover {
        background-color: #1e40af; /* hover:bg-blue-700 */
    }
  
</style>